<template>
  <div></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';
import type { AuthCompletedResponse } from '@/_helpers/interfaces';
import { configureApi } from '@/_helpers/plugins/api-configuration';
const { completeLoginFlow, logout } = useAuthStore();
const router = useRouter();
import cookieService from '@/_helpers/services/cookie.service';
onMounted(() => {
  const workspaceUsername = router.currentRoute.value.query.tenant as string;
  const token = router.currentRoute.value.query.token as string;
  const endHijack = router.currentRoute.value.query.end as string;
  console.log(workspaceUsername, token, endHijack);

  // Handle end hijack - clear all cookies and redirect to login
  if (endHijack) {
    logout();
    return;
  }

  if (token && workspaceUsername) {
    let authData = {
      access_token: router.currentRoute.value.query.token as string,
      refresh_token: '',
      id_token: '',
      expires_in: 0,
    };
    // Set tenant cookie before configuring API (required for API baseURL)
    // Use setAuthToken for persistent cookie (consistent with auth flow)
    cookieService.setAuthToken('tenant', workspaceUsername);
    cookieService.setAuthToken('is_hijack_session', 'true');
    configureApi();
    completeLoginFlow(authData as AuthCompletedResponse);
  }
});
</script>
